/**
 * @internal
 */
export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
//# sourceMappingURL=wait.js.map